import * as React from 'react';
import type { AccordionItemProps } from '../../Partials/AccordionComponent/AccordionItem';
import { AccordionList } from '../../Partials/AccordionComponent/AccordionList';
import { ButtonSize } from '../../Partials/Button/ButtonSize.csharp';
import { ButtonTier } from '../../Partials/Button/ButtonTier.csharp';
import { ButtonType } from '../../Partials/Button/ButtonType.csharp';
import { Link } from '../../Partials/Link/Link';
import { LinkType } from '../../Partials/Link/LinkType.csharp';
import type { AccordionItemBlockViewModel } from '../AccordionItemBlock/AccordionItemBlockViewModel.csharp';
import { HtmlDiv } from '~/Partials/Controls/HtmlDiv';
import styles from './AccordionBlock.module.css';

interface AccordionBlockProps {
    items: AccordionItemBlockViewModel[];
    className?: string;
    expandedAreaIds?: string[];
}

export const AccordionBlock: React.FC<React.PropsWithChildren<AccordionBlockProps>> = props => {
    const { expandedAreaIds, items, className } = props;

    function mapModelToGeneric(accordionItem: AccordionItemBlockViewModel): AccordionItemProps {
        const buttonStyles = accordionItem.linkAsButton
            ? {
                  type: LinkType.Button,
                  buttonType: ButtonType.Solid,
                  buttonTier: ButtonTier.LegacyPrimary,
                  buttonSize: ButtonSize.Large,
              }
            : {};

        return {
            headerContent: <span>{accordionItem.displayName}</span>,
            children: (
                <>
                    {accordionItem.introText && <HtmlDiv html={accordionItem.introText} />}
                    {accordionItem.callToAction?.href && accordionItem.callToAction?.label && (
                        <div className={styles.ContentLink}>
                            <Link {...accordionItem.callToAction} {...buttonStyles} />
                        </div>
                    )}
                </>
            ),
            index: accordionItem.id,
        };
    }

    return (
        <AccordionList
            className={className}
            accordions={items.map(mapModelToGeneric)}
            expandedAreaIds={expandedAreaIds}
        />
    );
};
